import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "@/components/AuthProvider";
import { buildLoginPath } from "@/lib/auth";

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center">
      <div className="animate-spin h-8 w-8 border-2 border-zinc-600 border-t-zinc-100 rounded-full"></div>
    </div>
  );
}

export default function ProtectedRoute() {
  const location = useLocation();
  const { isAuthenticated, isInitializing } = useAuth();

  if (isInitializing) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    const nextPath = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={buildLoginPath(nextPath)} replace />;
  }

  return <Outlet />;
}

